import { useEffect } from 'react'
import { formatFileSize } from 'react-common'
import { client } from 'react-common'
import { publicClient } from '@/store/api/publicCatalogApi'
import { removeAllHeaders } from '@/utils/removeHeaders'

const DEFAULT_SIZE = '0B'

const getFileSize = async (url: string, isPublic: boolean) => {
  try {
    if (!url) {
      return DEFAULT_SIZE
    }

    const _client = isPublic ? publicClient : client
    const headResponse = await _client.head(url, {
      // @ts-expect-error
      headers: (headers) => {
        return removeAllHeaders(headers)
      },
    })

    const sizeInBytes = headResponse.headers['content-length']
    if (!sizeInBytes) {
      return DEFAULT_SIZE
    }

    const size = formatFileSize(sizeInBytes)

    return size ?? DEFAULT_SIZE
  } catch (err) {
    console.error(err)

    return DEFAULT_SIZE
  }
}

const handleElementSize = async (element: Element, isPublic: boolean) => {
  const linkElement = element.querySelector('a.attach')
  if (!linkElement) {
    return
  }

  const url = linkElement.getAttribute('href')
  if (!url) {
    return
  }

  const extElement = element.querySelector('.attach__extension')
  if (!extElement) {
    return
  }

  const extText = extElement.textContent
  if (!extText) {
    return
  }

  const regexp = /\[(.*?)\]/g

  const ext = extText.matchAll(regexp).next().value?.[1] || extText
  extElement.innerHTML = `[${ext}], [...]`
  const size = await getFileSize(url, isPublic)

  const text = `[${ext}], [${size}]`

  extElement.innerHTML = text
}

export const useHandleAttachmentSize = (content: string, isPublic: boolean) => {
  useEffect(() => {
    const elements = [...document.getElementsByClassName('attach__container')]

    elements.forEach((element) => handleElementSize(element, isPublic))
  }, [content, isPublic])
}
